import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CountyAddress } from '../../../county-selection/county-selection.machine';

@Component({
  selector: 'app-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: [
    // This is a hack to get the dropdown to be styled correctly,
    // in the future we should implement our own dropdown component
    '../../boomer-forms/boomer-text-input/boomer-text-input.component.scss',
  ],
})
export class AddressFormComponent {
  @Input() form: UntypedFormGroup;
  @Input() label: string;
  @Input() savedAddress: CountyAddress;
  isLoadingCounties = false;
}
